import { configurationApi } from '../configurationApi';
import {
  RefundApprovalConfigType,
  RequiredApprovalLevelsResponse,
} from '../types/refundApprovalTypes';
import {
  WriteoffApprovalConfigType,
  ConfigureWriteoffApprovalRequest,
  RequiredWriteoffApprovalLevelsResponse,
  GetRequiredWriteoffApprovalLevelsRequest,
} from '../types/writeoffApprovalTypes';
import { ConfigureRefundApprovalRequest } from '../requests/configureRefundApprovalRequest';
import { GetRequiredApprovalLevelsRequest } from '../requests/getRequiredApprovalLevelsRequest';

const approvalConfigEndpoints = configurationApi.injectEndpoints({
  endpoints: (builder) => ({
    // Refund approval configuration
    configureRefundApproval: builder.mutation<
      RefundApprovalConfigType,
      ConfigureRefundApprovalRequest
    >({
      query: (request) => ({
        url: '/ConfigureRefunds',
        method: 'POST',
        body: request,
      }),
      invalidatesTags: ['RefundApproval'],
    }),

    getRequiredApprovalLevels: builder.query<
      RequiredApprovalLevelsResponse,
      GetRequiredApprovalLevelsRequest
    >({
      query: ({ centerId, refundAmount }) =>
        `/refundLevelsRequired?centerId=${encodeURIComponent(centerId)}&refundAmount=${refundAmount}`,
      providesTags: (result, error, { centerId }) => [{ type: 'RefundApproval', id: centerId }],
    }),

    // Writeoff approval configuration
    configureWriteoffApproval: builder.mutation<
      WriteoffApprovalConfigType,
      ConfigureWriteoffApprovalRequest
    >({
      query: (request) => ({
        url: '/ConfigureWriteoffs',
        method: 'POST',
        body: request,
      }),
      invalidatesTags: ['WriteoffApproval'],
    }),

    getRequiredWriteoffApprovalLevels: builder.query<
      RequiredWriteoffApprovalLevelsResponse,
      GetRequiredWriteoffApprovalLevelsRequest
    >({
      query: ({ centerId, writeoffAmount }) =>
        `/writeoffLevelsRequired?centerId=${encodeURIComponent(centerId)}&writeoffAmount=${writeoffAmount}`,
      providesTags: (result, error, { centerId }) => [{ type: 'WriteoffApproval', id: centerId }],
    }),
  }),
  overrideExisting: false,
});

export const {
  useConfigureRefundApprovalMutation,
  useGetRequiredApprovalLevelsQuery,
  useConfigureWriteoffApprovalMutation,
  useGetRequiredWriteoffApprovalLevelsQuery,
} = approvalConfigEndpoints;
